import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Scissors, Sparkles, Clock, Heart } from "lucide-react";

const services = [
  {
    icon: Scissors,
    title: "Corte de Cabelo",
    description: "Cortes modernos e clássicos com profissionais experientes",
    duration: "45 min",
    price: "R$ 50,00",
  },
  {
    icon: Sparkles,
    title: "Coloração",
    description: "Tintura profissional com produtos de alta qualidade",
    duration: "2h",
    price: "R$ 150,00",
  },
  {
    icon: Heart,
    title: "Tratamento Capilar",
    description: "Hidratação e reconstrução para cabelos danificados",
    duration: "1h 30min",
    price: "R$ 120,00",
  },
  {
    icon: Sparkles,
    title: "Manicure & Pedicure",
    description: "Cuidados completos para suas unhas",
    duration: "1h",
    price: "R$ 60,00",
  },
];

const ServicesSection = () => {
  const scrollToBooking = () => {
    const element = document.getElementById("agendamento");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="servicos" className="py-5 bg-muted">
      <Container className="py-5">
        {/* Header */}
        <div className="text-center mb-5">
          <span className="d-inline-block text-primary-custom fw-semibold mb-3">
            Nossos Serviços
          </span>
          <h2 className="display-6 fw-bold mb-3">
            Escolha o serviço ideal para você
          </h2>
          <p className="text-muted-custom mx-auto" style={{ maxWidth: "600px" }}>
            Oferecemos uma variedade de serviços de alta qualidade para atender 
            todas as suas necessidades.
          </p>
        </div>

        {/* Services Grid */}
        <Row className="g-4">
          {services.map((service, index) => (
            <Col key={index} sm={6} lg={3}>
              <Card className="card-custom shadow-card h-100 p-4">
                <Card.Body className="d-flex flex-column">
                  {/* Icon */}
                  <div className="icon-box bg-secondary-custom mb-4">
                    <service.icon size={28} className="text-primary-custom" />
                  </div>

                  {/* Content */}
                  <h5 className="fw-semibold mb-2">{service.title}</h5>
                  <p className="text-muted-custom small mb-3">{service.description}</p>

                  {/* Meta */}
                  <div className="d-flex align-items-center gap-3 small mb-4">
                    <div className="d-flex align-items-center gap-1 text-muted-custom">
                      <Clock size={14} />
                      {service.duration}
                    </div>
                    <div className="fw-semibold text-primary-custom">{service.price}</div>
                  </div>

                  {/* Button */}
                  <Button
                    variant="outline-primary"
                    className="mt-auto w-100"
                    style={{ borderColor: "#0d9488", color: "#0d9488" }}
                    onClick={scrollToBooking}
                  >
                    Agendar
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ServicesSection;